import React, { FC } from 'react'

import classes from './suspense-fallback.module.scss'
import { LoadingDots } from '../loading-dots'

export const SuspenseFallback: FC = () => {
  return (
    <div className={classes.root} data-testid="suspense-fallback">
      <div className={classes.header} />
      <div className={classes.body}>
        <LoadingDots />
      </div>
    </div>
  )
}
